import { render, staticRenderFns } from "./RecoveryEmail.vue?vue&type=template&id=008cc964&scoped=true&"
import script from "./RecoveryEmail.vue?vue&type=script&lang=js&"
export * from "./RecoveryEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008cc964",
  null
  
)

export default component.exports